<template>
   <pin
      class="variant-indicator"
      top="10px"
      left="10px">
      {{ $parent.$options.name }}
   </pin>
</template>

<script>
import Pin from '@components/Pin';
export default {
   name: 'VariantIndicator',
   components: { Pin },
};
</script>

<style>
.variant-indicator {
   color: black;
   font-size: 12px;
   background-color: white;
   border: 1px solid #ccc;
   padding: 2px 6px;
   opacity: 0;
   transition: opacity 0.3s;
}
.show-meta .variant-indicator {
   opacity: 1;
}
</style>
